/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitDtoV2 } from './PaymentSplitDtoV2';
import {
    PaymentSplitDtoV2FromJSON,
    PaymentSplitDtoV2FromJSONTyped,
    PaymentSplitDtoV2ToJSON,
    PaymentSplitDtoV2ToJSONTyped,
} from './PaymentSplitDtoV2';

import { type Cash, CashFromJSONTyped, CashToJSON, CashToJSONTyped } from './Cash';
import { type FavritGiftCard, FavritGiftCardFromJSONTyped, FavritGiftCardToJSON, FavritGiftCardToJSONTyped } from './FavritGiftCard';
import { type Invoice, InvoiceFromJSONTyped, InvoiceToJSON, InvoiceToJSONTyped } from './Invoice';
import { type MobileCardTerminal, MobileCardTerminalFromJSONTyped, MobileCardTerminalToJSON, MobileCardTerminalToJSONTyped } from './MobileCardTerminal';
/**
 * 
 * @export
 * @interface InitiateUnintegratedPaymentV2Request
 */
export interface InitiateUnintegratedPaymentV2Request {
    /**
     * 
     * @type {number}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    amountMinorUnits: number;
    /**
     * 
     * @type {Currency}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    paymentReference: string;
    /**
     * 
     * @type {Array<PaymentSplitDtoV2>}
     * @memberof InitiateUnintegratedPaymentV2Request
     */
    paymentSplits: Array<PaymentSplitDtoV2>;
}



/**
 * Check if a given object implements the InitiateUnintegratedPaymentV2Request interface.
 */
export function instanceOfInitiateUnintegratedPaymentV2Request(value: object): value is InitiateUnintegratedPaymentV2Request {
    if (!('amountMinorUnits' in value) || value['amountMinorUnits'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentSplits' in value) || value['paymentSplits'] === undefined) return false;
    return true;
}

export function InitiateUnintegratedPaymentV2RequestFromJSON(json: any): InitiateUnintegratedPaymentV2Request {
    return InitiateUnintegratedPaymentV2RequestFromJSONTyped(json, false);
}

export function InitiateUnintegratedPaymentV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateUnintegratedPaymentV2Request {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['paymentMethod'] === 'Cash') {
            return CashFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['paymentMethod'] === 'FavritGiftCard') {
            return FavritGiftCardFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['paymentMethod'] === 'Invoice') {
            return InvoiceFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['paymentMethod'] === 'MobileCardTerminal') {
            return MobileCardTerminalFromJSONTyped(json, ignoreDiscriminator);
        }

    }
    return {
        
        'amountMinorUnits': json['amountMinorUnits'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentMethod': json['paymentMethod'],
        'paymentReference': json['paymentReference'],
        'paymentSplits': ((json['paymentSplits'] as Array<any>).map(PaymentSplitDtoV2FromJSON)),
    };
}

export function InitiateUnintegratedPaymentV2RequestToJSON(json: any): InitiateUnintegratedPaymentV2Request {
    return InitiateUnintegratedPaymentV2RequestToJSONTyped(json, false);
}

export function InitiateUnintegratedPaymentV2RequestToJSONTyped(value?: InitiateUnintegratedPaymentV2Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['paymentMethod']) {
            case 'Cash':
                return CashToJSONTyped(value as Cash, ignoreDiscriminator);
            case 'FavritGiftCard':
                return FavritGiftCardToJSONTyped(value as FavritGiftCard, ignoreDiscriminator);
            case 'Invoice':
                return InvoiceToJSONTyped(value as Invoice, ignoreDiscriminator);
            case 'MobileCardTerminal':
                return MobileCardTerminalToJSONTyped(value as MobileCardTerminal, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'amountMinorUnits': value['amountMinorUnits'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentMethod': value['paymentMethod'],
        'paymentReference': value['paymentReference'],
        'paymentSplits': ((value['paymentSplits'] as Array<any>).map(PaymentSplitDtoV2ToJSON)),
    };
}

